import { IEssentialInfo, IUserProfile } from './profile';
import { CompanyData, ICompanyData } from './company-data';
import { EmployerPersonalData } from './employer-personal-data';

export class EmployerProfile {
  personalData: EmployerPersonalData;
  companyData: CompanyData;
  essentialInfo: IEssentialInfo;

  constructor( personalData: IUserProfile, companyData: ICompanyData ) {
    this.personalData = new EmployerPersonalData(personalData);
    this.companyData = new CompanyData(companyData);
    this.essentialInfo = personalData.essentialInfo || {};
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/employer-profile.ts